import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Lock, Network } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { ADMIN_PATH, errorMessage } from "../../lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (user) return <Navigate to={`${ADMIN_PATH}/panel`} replace />;

  const submit = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    const { email, password } = Object.fromEntries(new FormData(e.currentTarget).entries());
    try { await login(email, password); toast.success("مرحباً بك في لوحة الإدارة"); navigate(`${ADMIN_PATH}/panel`); }
    catch (err) { setError(errorMessage(err, "بيانات الدخول غير صحيحة")); }
    finally { setLoading(false); }
  };

  return (
    <main className="admin-login" dir="rtl" data-testid="admin-login-page">
      <div className="panel">
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 26 }}>
          <span className="brand-mark"><Network size={22} /></span>
          <div><span className="kicker">Control Room</span><h1 style={{ fontSize: 22, fontWeight: 800, marginTop: 6 }}>دخول الإدارة</h1></div>
        </div>
        {error && <div className="error-text" style={{ marginBottom: 14 }} data-testid="admin-login-error">{error}</div>}
        <form className="form" onSubmit={submit} style={{ marginTop: 0 }}>
          <label className="full">البريد الإلكتروني<input type="email" name="email" required autoComplete="username" data-testid="admin-email-input" /></label>
          <label className="full">كلمة المرور<input type="password" name="password" required autoComplete="current-password" data-testid="admin-password-input" /></label>
          <button className="btn btn-primary" type="submit" disabled={loading} data-testid="admin-login-submit">{loading ? <span className="loader" /> : <><Lock size={16} />دخول</>}</button>
        </form>
      </div>
    </main>
  );
}
